module.exports = {"Rule":"Rule","Rules":"Rules","Indexing Rules Failed":"Indexing Rules Failed"}